import { apiFetch } from "./index";
import {
  loginRequestSchema,
  loginResponseSchema,
  userSchema,
  signupRequestSchema,
  signupResponseSchema,
  forgotPasswordRequestSchema,
  forgotPasswordResponseSchema,
  resetPasswordRequestSchema,
  resetPasswordResponseSchema,
  type LoginRequest,
  type UserSchema,
  type LoginUserSchema,
  type SignupRequest,
  type ForgotPasswordRequest,
  type ResetPasswordRequest,
} from "./schemas";

export async function loginApi(credentials: LoginRequest): Promise<{ user: LoginUserSchema; jwt: string }> {
  // Validate request data
  loginRequestSchema.parse(credentials);

  const response = await apiFetch(
    "/login.json",
    {
      method: "POST",
      headers: {
        "Accept": "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ user: credentials }),
    },
    loginResponseSchema
  );

  const jwt = response.headers.get("Authorization");
  if (!jwt) {
    throw new Error("No JWT token received");
  }

  return {
    user: response.data.user,
    jwt: jwt.replace("Bearer ", "")
  };
}

export async function signupApi(userData: SignupRequest): Promise<{ user: LoginUserSchema; jwt: string }> {
  // Validate request data
  signupRequestSchema.parse(userData);

  const response = await apiFetch(
    "/api/v2/auth/register",
    {
      method: "POST",
      headers: {
        "Accept": "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ user: userData }),
    },
    signupResponseSchema
  );

  const jwt = response.headers.get("Authorization");
  if (!jwt) {
    throw new Error("No JWT token received");
  }

  return {
    user: response.data.user,
    jwt: jwt.replace("Bearer ", "")
  };
}

export async function forgotPasswordApi(data: ForgotPasswordRequest): Promise<{ message: string }> {
  // Validate request data
  forgotPasswordRequestSchema.parse(data);

  const response = await apiFetch(
    "/api/v2/auth/forgot_password",
    {
      method: "POST",
      headers: {
        "Accept": "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ user: data }),
    },
    forgotPasswordResponseSchema
  );

  return response.data;
}

export async function resetPasswordApi(data: ResetPasswordRequest): Promise<{ user: LoginUserSchema; jwt: string }> {
  // Validate request data
  resetPasswordRequestSchema.parse(data);

  const response = await apiFetch(
    "/api/v2/auth/reset_password",
    {
      method: "POST",
      headers: {
        "Accept": "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ user: data }),
    },
    resetPasswordResponseSchema
  );

  const jwt = response.headers.get("Authorization");
  if (!jwt) {
    throw new Error("No JWT token received");
  }

  return {
    user: response.data.user,
    jwt: jwt.replace("Bearer ", "")
  };
}

export async function getCurrentUser(): Promise<UserSchema> {
  const { data } = await apiFetch<UserSchema>(
    "/api/v2/user/me.json",
    undefined,
    userSchema
  );
  return data;
}

export async function logoutApi(): Promise<void> {
  await apiFetch("/logout.json", {
    method: "DELETE",
    headers: {
      "Accept": "application/json",
    },
  });
}
